import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "maritime-law.webp",
    title: "Derecho Aduanero",
    crumb: "Derecho Aduanero",
  },
  icon: "fa-solid fa-warehouse",
  shortDescription:
    "Asesoría integral en derecho aduanero y comercio exterior para optimizar regímenes, cumplimiento y operaciones logísticas.",

  title: "Derecho Aduanero",
  features: {
    title: "Derecho Aduanero",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Planificación aduanera, cumplimiento normativo y diseño de estrategias operativas para operaciones de importación, exportación y tránsito.",
    description: `Servicios de diagnóstico y planificación aduanera: identificamos el marco normativo aplicable, clasificamos mercancías, proponemos regímenes y diseñamos procesos operativos que minimicen riesgos y costos aduaneros, garantizando cumplimiento frente a las autoridades competentes.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "diagnostico",
        title: "Diagnóstico y análisis del entorno aduanero",
        summary:
          "Evaluación integral del contexto operativo: rutas logísticas, puntos de entrada/salida y actores involucrados (agentes de carga, operadores portuarios).",
        details:
          "Realizamos un mapeo de la cadena logística y un diagnóstico de cumplimiento actual que identifica cuellos de botella, riesgos de incumplimiento y oportunidades de optimización en procesos de importación/exportación y tránsito aduanero.",
        deliverables: [
          "Informe diagnóstico aduanero",
          "Mapa de procesos logísticos y puntos de riesgo",
          "Recomendaciones priorizadas de mejora",
        ],
        requiredDocs: [
          "Flujo de import/export actual",
          "Contratos con agentes/logística",
          "Documentación aduanera reciente (pedimentos, manifiestos)",
        ],
        icon: "fa-solid fa-search",
        image: global.services + "customs_law/1.webp",
      },
      {
        key: "normativa",
        title:
          "Identificación de la normativa aplicable y clasificación arancelaria",
        summary:
          "Determinamos el marco legal, aranceles aplicables y la correcta clasificación arancelaria (HS) de las mercancías.",
        details:
          "Analizamos leyes, decretos, resoluciones y tarifas arancelarias vigentes; realizamos la clasificación arancelaria (HS/SA) y valoración aduanera conforme a reglas internacionales y locales, reduciendo riesgos de ajustes y sanciones.",
        deliverables: [
          "Ficha de clasificación arancelaria por producto",
          "Informe de obligaciones normativas aplicables",
          "Cálculo estimado de gravámenes y costos asociados",
        ],
        requiredDocs: [
          "Ficha técnica/comercial de mercancías",
          "Facturas proforma/finales",
          "Documentación de origen (certificados si aplica)",
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "customs_law/2.webp",
      },
      {
        key: "regimenes",
        title:
          "Planificación de regímenes aduaneros y aprovechamiento de beneficios",
        summary:
          "Diseño y evaluación de regímenes aduaneros (depósito fiscal, zona franca, tránsito, admisión temporal, régimen de perfeccionamiento).",
        details:
          "Evaluamos la conveniencia de regímenes aduaneros según operaciones (importación temporal, reexportación, transformación, almacenamiento en depósito fiscal o zona franca), optimizando costos arancelarios y de almacenamiento, y gestionando requisitos para acceder a beneficios como draw-back o exoneraciones.",
        deliverables: [
          "Evaluación de regímenes recomendados",
          "Plan de implementación de régimen aduanero",
          "Modelo de ahorro estimado y flujo operativo",
        ],
        requiredDocs: [
          "Historial de importaciones/exportaciones",
          "Contratos de almacenaje/transporte",
          "Permisos o certificaciones previas",
        ],
        icon: "fa-solid fa-box-open",
        image: global.services + "customs_law/3.webp",
      },
      {
        key: "optimización",
        title: "Optimización del cumplimiento normativo y procesos operativos",
        summary:
          "Mejoras en procedimientos internos, documentación y flujos de despacho para reducir tiempos y contingencias.",
        details:
          "Diseñamos procedimientos estandarizados para despacho aduanero, validación documental previa, conciliaciones contables-aduaneras, controles de inventario y preparación de documentación para auditorías, incorporando automatización y checklists para reducción de errores.",
        deliverables: [
          "Manual de procesos aduaneros",
          "Checklists para despacho y recepción",
          "Plantillas de documentación y control",
        ],
        requiredDocs: [
          "Procedimientos actuales",
          "Sistemas de gestión/ERP (si aplica)",
          "Reportes de discrepancias previas",
        ],
        icon: "fa-solid fa-cogs",
        image: global.services + "customs_law/4.webp",
      },
      {
        key: "operativa",
        title:
          "Diseño de estrategias operativas y cadena de suministro aduanera",
        summary:
          "Rediseño de la cadena logística para mejorar tiempos, costos e integración con operadores aduaneros y portuarios.",
        details:
          "Proponemos rutas alternativas, acuerdos con operadores, optimización de consolidación/desconsolidación y sincronización de documentación para anticipar despacho. Incluye recomendaciones para selección de Incoterms adecuados y gestión contractual con agentes aduaneros y navieras.",
        deliverables: [
          "Plan operativo de cadena de suministro aduanera",
          "Modelo de acuerdos con operadores y SLA",
          "Recomendación de Incoterms y cláusulas contractuales",
        ],
        requiredDocs: [
          "Contratos con agentes y transportistas",
          "Registros de tiempos y demoras",
          "Políticas de inventario y consolidación",
        ],
        icon: "fa-solid fa-route",
        image: global.services + "customs_law/5.webp",
      },
      {
        key: "riesgos",
        title: "Gestión de riesgos, auditorías aduaneras y capacitación",
        summary:
          "Programas de control, auditoría interna y formación para mitigar sanciones y mejorar cumplimiento continuo.",
        details:
          "Implementamos planes de gestión de riesgo aduanero, preparamos a la organización para inspecciones y auditorías, y ofrecemos formación específica para equipos operativos y administrativos sobre clasificación, valoración, documentación y controles preventivos.",
        deliverables: [
          "Programa de gestión de riesgos aduaneros",
          "Informe de auditoría interna y plan de acción",
          "Plan de capacitación a medida (workshops y materiales)",
        ],
        requiredDocs: [
          "Informes de auditorías previas",
          "Registros de incumplimientos y multas",
          "Lista de personal clave y roles operativos",
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "customs_law/6.webp",
      },
    ],
  },
  ctaText: "Solicitar asesoría aduanera",
  ctaLink: "/contacto?servicio=derecho-aduanero",
};
